import React from "react";
import { Button, Grid, Modal, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import "animate.css/animate.css";
import mapIcon from "../../images/Homescreen.svg";

const EndScriptModal = ({
  classes,
  endScriptModal,
  setEndScriptModal,
}) => {
  return (
    <Modal open={endScriptModal}>
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Grid className={classes.evaluatorModalContainer}>
          <Typography className={classes.closeIcon} onClick={() => setEndScriptModal(false) } >X</Typography>
          <img src={mapIcon} className={classes.gdpIcon} />
          <Typography className={classes.evalDesc}>
            Jack stands tall in his castle pondering the functions of money. Using money as a unit of
            account he knows he’s the richest in the land, truly a giant amongst peasants. His vault
            overflows with cash, a store of value. Yet, he wonders about money as a medium of
            exchange. Sure he has bought many fine things with money. But he’d trade all his
            money to go back to being the farm boy excited by magic beans, and yet that is one
            exchange that he knows is impossible.
          </Typography>
          <Grid container justify="center">
            <Button className={classes.submitButton} onClick={() => setEndScriptModal(false) }> SEE SCORE </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default withStyles(styles)(EndScriptModal);
